var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScanGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 8.1V13.5H8.1V8.1H13.5ZM16.2 5.4H5.4V16.2H16.2V5.4ZM13.5 22.5V27.9H8.1V22.5H13.5ZM16.2 19.8H5.4V30.6H16.2V19.8ZM27.9 8.1V13.5H22.5V8.1H27.9ZM30.6 5.4H19.8V16.2H30.6V5.4ZM19.8 19.8H22.5V22.5H19.8V19.8ZM22.5 22.5H25.2V25.2H22.5V22.5ZM25.2 19.8H27.9V22.5H25.2V19.8ZM19.8 25.2H22.5V27.9H19.8V25.2ZM22.5 27.9H25.2V30.6H22.5V27.9ZM25.2 25.2H27.9V27.9H25.2V25.2ZM27.9 22.5H30.6V25.2H27.9V22.5ZM27.9 27.9H30.6V30.6H27.9V27.9ZM36 9H32.4V3.6H27V0H36V9ZM36 36V27H32.4V32.4H27V36H36ZM0 36H9V32.4H3.6V27H0V36ZM0 0V9H3.6V3.6H9V0H0Z",
    fill: "#0E3527"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanGreen);
export default __webpack_public_path__ + "static/media/scan-green.40020b88dd71bb7d3598a7da352ef737.svg";
export { ForwardRef as ReactComponent };